import DownloadIcon from 'icons/Download.icon';
import EyeIcon from 'icons/Eye.icon';
import { IconProp } from 'models/Icon';
import { ObjectValues } from 'types';

export const SORTING_VALUES = {
  NAME: 'sortName',
  NUMBER_OF_VIEWS: 'numberOfViews',
  NUMBER_OF_DOWNLOADS: 'numberOfDownloads',
  LAST_ACCESS: 'lastAccessDate',
};

export type SortingValues = ObjectValues<typeof SORTING_VALUES>;

export const SORTING_VALUES_COPY = {
  [SORTING_VALUES.NAME]: 'a-z',
  [SORTING_VALUES.NUMBER_OF_VIEWS]: '',
  [SORTING_VALUES.NUMBER_OF_DOWNLOADS]: '',
  [SORTING_VALUES.LAST_ACCESS]: 'lastAccess',
} as Record<SortingValues, string>;

export const SORTING_VALUES_ICON = {
  [SORTING_VALUES.NAME]: () => null,
  [SORTING_VALUES.NUMBER_OF_VIEWS]: EyeIcon,
  [SORTING_VALUES.NUMBER_OF_DOWNLOADS]: DownloadIcon,
  [SORTING_VALUES.LAST_ACCESS]: () => null,
} as Record<SortingValues, IconProp | null>;
